import axios from "axios";
import { server } from "../../server";

export const loadSeller = () => async (dispatch) => {
  try {
    const response = await axios.get(`${server}/shop/get-seller-info`, {
      withCredentials: true,
    });

    dispatch({
      type: 'LOAD_SELLER_SUCCESS',
      payload: response.data.seller, // Ensure response structure matches your API
    });
  } catch (error) {
    console.error('Error loading seller:', error);
    dispatch({
      type: 'LOAD_SELLER_FAILURE',
      payload: error.message, // Optionally handle error payload
    });
  }
};

// Get all orders of user
export const getAllOrdersOfUser = (userId, limit = 200, lastOrderDate = null) => async (dispatch, getState) => {
  try {
    dispatch({ type: "getAllOrdersUserRequest" });

    const state = getState();
    const cachedOrders = state.order.orders;

    // Fetch only new orders if the lastOrderDate exists
    const queryParams = lastOrderDate ? `?limit=${limit}&lastOrderDate=${lastOrderDate}` : `?limit=${limit}`;
    const { data } = await axios.get(`${server}/order/get-all-orders/${userId}${queryParams}`);

    if (lastOrderDate) {
      // Append new orders to the cache
      dispatch({
        type: "getAllOrdersUserSuccess",
        payload: [...cachedOrders, ...data.orders],
      });
    } else {
      // Load initial orders
      dispatch({
        type: "getAllOrdersUserSuccess",
        payload: data.orders,
      });
    }
  } catch (error) {
    dispatch({
      type: "getAllOrdersUserFailed",
      payload: error.response?.data?.message || "Failed to fetch user orders",
    });
  }
};


// Get all orders of seller
export const getAllOrdersOfShop = (shopId, limit = 200, lastOrderDate = null) => async (dispatch, getState) => {
  try {
    dispatch({ type: "getAllOrdersShopRequest" });

    const state = getState();
    const cachedOrders = state.order.orders;

    const queryParams = lastOrderDate ? `?limit=${limit}&lastOrderDate=${lastOrderDate}` : `?limit=${limit}`;
    const { data } = await axios.get(`${server}/order/get-seller-all-orders/${shopId}${queryParams}`);

    if (lastOrderDate) {
      dispatch({
        type: "getAllOrdersShopSuccess",
        payload: [...cachedOrders, ...data.orders],
      });
    } else {
      dispatch({
        type: "getAllOrdersShopSuccess",
        payload: data.orders,
      });
    }
  } catch (error) {
    dispatch({
      type: "getAllOrdersShopFailed",
      payload: error.response?.data?.message || "Failed to fetch seller orders",
    });
  }
};


// Get all orders of Admin

// Redux actions to cache admin orders
export const getAllOrdersOfAdmin = (limit = 500, lastOrderDate = null, forceRefresh = false) => async (dispatch, getState) => {
  try {
    dispatch({ type: "adminAllOrdersRequest" });

    const state = getState();
    const cachedOrders = state.order.adminOrders;

    // If forceRefresh is false and cachedOrders exist without a lastOrderDate, use cache
    if (cachedOrders.length > 0 && !lastOrderDate && !forceRefresh) {
      dispatch({
        type: "adminAllOrdersSuccess",
        payload: cachedOrders,
      });
      return;
    }

    const queryParams = lastOrderDate ? `?limit=${limit}&lastOrderDate=${lastOrderDate}` : `?limit=${limit}`;
    const { data } = await axios.get(`${server}/order/admin-all-orders${queryParams}`, {
      withCredentials: true,
    });

    if (lastOrderDate) {
      dispatch({
        type: "adminAllOrdersSuccess",
        payload: [...cachedOrders, ...data.orders], // Append new orders
      });
    } else {
      dispatch({
        type: "adminAllOrdersSuccess",
        payload: data.orders, // Load initial or refreshed orders
      });
    }
  } catch (error) {
    dispatch({
      type: "adminAllOrdersFailed",
      payload: error.response?.data?.message || "Failed to fetch admin orders",
    });
  }
};

